import { render, staticRenderFns } from "./VendorsMap.vue?vue&type=template&id=0de1f8bf&scoped=true&"
import script from "./VendorsMap.vue?vue&type=script&lang=js&"
export * from "./VendorsMap.vue?vue&type=script&lang=js&"
import style0 from "./VendorsMap.vue?vue&type=style&index=0&id=0de1f8bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de1f8bf",
  null
  
)

export default component.exports